const _ = require('lodash');
const React = require('react');
const createReactClass = require('create-react-class');
const assign = require('object-assign');
const classNames = require('classnames');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;

const FormStore = FuzzyReaction.Stores.FormStore;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Fz = FuzzyReaction.require('components', 'Column', 'Row', 'Modal', 'Form',
    'Table', 'Button', 'PaginatedButtons', 'PerPageSelector', 'PageSearch', 'actions');

const CastPreview = require('./CastPreview');
const CastStore = require('../../../stores/CastStore');
const TracksStore = require('../../../stores/TracksStore');
const CastManagementMixin = require('./CastManagementMixin');
const UploadProgressMixin = require('../../components/UploadProgressBarMixin');
const UploadProgress = require('../../components/UploadProgress');
const InstructorStore = require('../../../stores/InstructorsStore');

const TrackManagement = createReactClass({
    displayName: 'TrackManagement',

    mixins: [CastManagementMixin, UploadProgressMixin],

    getInitialState: function () {
        return {
            cast: {},
            castRecording: {
                audio: null
            },
            tracks: [],
            selectedTracks: [],
            progress: {
                loaded: 0,
                total: 100
            },
            formIsValid: true,
            openAddVoiceTrackModal: false,
            openCancelWarning: false,
            openUploadProgressModal: false,
            openPreviewModal: false,
            progressBarState: 'yellow'
        }
    },

    /**
     * Set up tracks resource
     */
    resourceActions: new ResourceActions('tracks'),

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            include: [],
            pagination: {
                per_page: 50
            },
            filters: {
                is_dmca_restricted: "NOT_NULL"
            }
        },
        dataNode: 'data'
    },

    getCastOptions: {
        modifiers: {
            include: ['tracks', 'genres', 'movements'],
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            include: ['tracks', 'genres', 'movements'],
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    /**
     * Cast recording form key
     */
    castRecordingFormKey: 'castRecording',

    /**
     * DMCA checkbox
     */
    dmcaCheckbox: 'dmcaCheckbox',

    /**
     * Tracks list table keys
     */
    tableKeys: {
        'Artist': 'artist',
        'Track Title': 'title',
        'Album': 'album',
        'Album Artist': 'album_artist',
        'Duration': 'duration',
        'DMCA': 'is_dmca_restricted'
    },

    /**
     * Selected tracks list table keys
     */
    selectTracksKeys: {
        'Artist': 'artist',
        'Track Title': 'title',
        'Duration': 'duration',
        'DMCA': 'is_dmca_restricted'
    },

    /**
     * Determine if the cast satisfies a minimum length
     *
     * @returns {boolean}
     * @private
     */
    _castSatisfiesMinimum: function () {
        return this.selectedTracksLength(this.state.cast.tracks) >= (this.state.cast.target_duration - 180);
    },

    /**
     * Request track table data
     *
     * @param modifiers
     */
    requestTableData: function (modifiers) {
        // Add DMCA filtering
        this.filterDmca();

        // Merge modifiers with already present ones
        if (modifiers) {
            this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});
        }

        this.resourceActions.listResource(this.getOptions);
    },

    filterDmca: function () {
        const checkbox = document.getElementById(this.dmcaCheckbox)

        if (checkbox.checked) {
            this.getOptions.modifiers.filters.is_dmca_restricted = "=0";
        } else {
            this.getOptions.modifiers.filters.is_dmca_restricted = "NOT_NULL";
        }
    },

    /**
     * Determine the appropriate resource operation and build cast data
     *
     * @return void
     */
    performOperation: function () {
        const resource = new ResourceActions('casts');
        const cast = this.state.cast;
        cast.tracks = this.state.selectedTracks;

        this._updateTrackDeltas(cast);

        if (typeof cast.id === 'undefined') {
            resource.createResource(cast, this.sendOptions);
            this.props.history.push('/cast-library');
        } else {
            resource.updateResource(cast, this.sendOptions);
        }
    },

    /**
     * Handle uploading a voice track for a cast separately
     */
    uploadVoiceTrack: function () {
        const resource = new ResourceActions('casts');
        const options = this.sendOptions;
        options.contentType = 'form';
        options.deepObjectParse = true;
        options.overrideMethod = 'post';

        // Reconstruct the cast and send as a whole.
        const cast = this.state.cast;
        cast.tracks = this.state.selectedTracks;
        cast.audio = this.state.castRecording.audio;

        // Workaround for laravel not accepting formdata on PUT
        if (typeof cast.id !== 'undefined') {
            cast._method = 'PUT';
        }

        this._updateTrackDeltas(cast);

        this.setState({
            openUploadProgressModal: true,
            openAddVoiceTrackModal: false,
            // Reset upload progress
            progress: {
                loaded: 0,
                total: 100
            }
        }, function () {
            if (typeof cast.id === 'undefined') {
                resource.createResource(cast, options);
            } else {
                // Set cast to unpublished for the duration of the transcoding job (set to published upon
                // completion of transcoding)
                cast.is_published = 0;

                resource.updateResource(cast, options);
            }
        });
    },

    /**
     * Handle a fired action
     *
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'dragSort':
                this.setState({
                    selectedTracks: resource
                });
                break;
            case 'next':
                this.setState({
                    openAddRecordingModal: true
                });
                break;
            case 'add':
                this.selectTrack(resource);
                break;
            case 'remove':
                this.removeTrack(resource);
                break;
            case 'preview':
                this.setState({
                    openPreviewModal: true
                });
                break;
            case 'cancel':
                this.setState({
                    openCancelWarning: true
                });
                break;
            case 'confirmSave':
                this.performOperation();
                break;
            case 'addVoice':
                this.setState({
                    openAddVoiceTrackModal: true
                });
                break;
        }
    },

    /**
     * Filter out the unselected track from the selected tracks list
     *
     * @param removedTrack
     */
    removeTrack: function (removedTrack) {
        this.setCastUnpublished();
        this.setState(function (previousState) {
            previousState.selectedTracks = _.filter(previousState.selectedTracks, function (track) {
                return track.id !== removedTrack.id;
            });

            previousState.cast.tracks = previousState.selectedTracks;

            return previousState;
        });
    },

    /**
     * Add a track to the selected tracks list
     *
     * @param track
     * @todo further validation rules
     */
    selectTrack: function (track) {
        // Don't add tracks if we've reached the target duration + buffer
        //Buffer = 900 seconds = 15 minutes, this is to avoid issues where it's needed to add a bit of extra
        //time to the workout and this way avoid restrictions regarding saving workouts with some overtime.
        if ((this.selectedTracksLength(this.state.cast.tracks) + track.duration) >= (this.state.cast.target_duration + 900)) {
            return;
        }

        this.setCastUnpublished();

        this.setState(function (previousState) {
            previousState.selectedTracks.push(track);
            previousState.cast.tracks = previousState.selectedTracks;

            return previousState;
        });
    },

    /**
     * Set cast to unpublished when we make changes that require updates to transcoding
     * or VBR playlists.
     *
     * @return void
     */
    setCastUnpublished: function () {
        if (this.state.cast.is_published) {
            this.setState(function (previousState) {
                previousState.cast.is_published = 0;
            });
        }
    },

    /**
     * Filter out the currently selected tracks so they don't appear in the table
     *
     * @returns {array}
     */
    filterSelectedTracks: function () {
        const selectedIds = _.map(this.state.selectedTracks, 'id');

        return _.filter(this.state.tracks, function (track) {
            return selectedIds.indexOf(track.id) < 0; // >0 for already selected tracks
        })
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        const cast = CastStore.getStoredCast();

        if (Object.keys(cast).length === 0) {
            const params = this.props.match.params || {};
            this.props.history.push(`/cast-library/${params.id}`);
        }

        this.setState({
            cast: cast,
            selectedTracks: cast.tracks || [],
            resourceOperation: typeof cast.id === 'undefined' ? 'create' : 'edit'
        });

        this.requestTableData();

        CastStore.addChangeListener(this._onChange);
        TracksStore.addChangeListener(this._onChange);
        FormStore.addChangeListener(this.bindResource);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        CastStore.removeChangeListener(this._onChange);
        TracksStore.removeChangeListener(this._onChange);
        FormStore.removeChangeListener(this.bindResource);
    },

    /**
     * Change handler for FormStore changes
     */
    bindResource: function () {
        this.setState({
            castRecording: FormStore.getResource(this.castRecordingFormKey),
            formIsValid: FormStore.isFormValid(this.castRecordingFormKey)
        });
    },

    /**
     * Handle change events
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            tracks: TracksStore.getResourceListData(),
            progress: CastStore.getUploadProgress()
        });
    },

    /**
     * Update selected track deltas
     *
     * @param cast
     * @private
     */
    _updateTrackDeltas: function (cast) {
        cast.tracks = cast.tracks.map(function (track, index) {
            track.pivot = {
                delta: index
            };
            return track;
        });
    },

    /**
     * Handle modal close
     */
    closeModal: function () {
        this.setState({
            openPreviewModal: false,
            openCancelWarning: false,
            openAddVoiceTrackModal: false,
            openUploadProgressModal: false
        });
    },

    /**
     * Table options for the tracks list
     *
     * @returns {object}
     */
    tracksListOptions: function () {
        const toMinutesString = this.toMinutesString;
        return {
            actionableRows: true,
            actions: ['add:success'],
            actionsCallback: this.handleAction,
            mutators: {
                duration: function (duration) {
                    return toMinutesString(duration);
                },
                is_dmca_restricted: function (value) {
                    return value === 1 ? 'Yes' : 'No';
                }
            },
            sortable: ['artist', 'title', 'album', 'album_artist', 'is_dmca_restricted'],
            noPanel: true
        };
    },

    /**
     * Table options for selected tracks list
     *
     * @returns {object}
     */
    selectedTracksListOptions: function () {
        const toMinutesString = this.toMinutesString;
        return {
            actionableRows: true,
            actions: ['remove:danger'],
            actionsCallback: this.handleAction,
            mutators: {
                duration: function (duration) {
                    return toMinutesString(duration);
                },
                is_dmca_restricted: function (value) {
                    return value === 1 ? 'Yes' : 'No';
                }
            },
            draggable: true,
            noPanel: true,
            hideSpinner: true,
            emptyText: 'No tracks selected yet :('
        };
    },

    progressBarState: function () {
        return classNames({
            'progress-bar': true,
            'progress-bar-striped': true,
            'progress-bar-animated': true,
            'warning': !this._castSatisfiesMinimum()
        });
    },

    transitionToLibrary: function () {
        this.props.history.push('/cast-library');
    },

    _castInstructor: function () {
        const instructors = InstructorStore.getResourceListData();

        if (instructors.length === 0 || typeof this.state.cast.instructor_id === 'undefined') {
            return 'Instructor';
        }

        return _.filter(instructors, {id: Number(this.state.cast.instructor_id)})[0].name;
    },

    render: function () {
        const buttonMods = ['primary'];

        if (!this._castSatisfiesMinimum()) {
            buttonMods.push('disabled');
        }

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Fz.Row classes="align-items-center">
                        <Fz.Column grid="lg" size="6">
                            <h1 className="page-header">Manage Cast Tracks</h1>
                        </Fz.Column>
                    </Fz.Row>
                    <Fz.Column grid="lg" size="12">
                        <div className="card card-default">
                            <div className="card-body">
                                <Fz.Row>
                                    <Fz.Column grid="lg" size="4">
                                        <h4>Add Music Tracks</h4>
                                        <h5>Search the music library for a specific track below.</h5>
                                    </Fz.Column>

                                    <Fz.Column grid="lg" size="8">
                                        <p className="float-right">
                                            <Fz.Button action="cancel" text="cancel" handleAction={this.handleAction}/>
                                            <Fz.Button action="preview" text="Preview" handleAction={this.handleAction}
                                                       mods={['info']}/>
                                            <Fz.Button action="confirmSave" text="Save For Later"
                                                       disabled={!this._castSatisfiesMinimum()}
                                                       handleAction={this.handleAction} mods={buttonMods}/>
                                            <Fz.Button action="addVoice" text="Add Voice Track"
                                                       disabled={!this._castSatisfiesMinimum()}
                                                       handleAction={this.handleAction} mods={buttonMods}/>
                                        </p>
                                    </Fz.Column>
                                </Fz.Row>
                                <Fz.Row>
                                    <Fz.Column grid="lg" size="4">
                                        <Fz.Row>
                                            <Fz.Column grid="lg" size="12">
                                                <h4>{this.state.cast.title}</h4>
                                                <p>Cast Progress</p>

                                                <div className="progress cast-progress-bar">
                                                    <div className="cast-details-tracks-length">
                                                        {this.toMinutesString(this.selectedTracksLength(this.state.cast.tracks))}
                                                    </div>

                                                    <div className="cast-details-target-duration">
                                                        {this.toMinutesString(this.state.cast.target_duration)}
                                                    </div>

                                                    <div className={this.progressBarState()}
                                                         style={this.progressBarWidth(this.state.cast)}/>
                                                </div>
                                            </Fz.Column>
                                        </Fz.Row>

                                        <Fz.Row>
                                            <Fz.Column grid="lg" size="12">
                                                <Fz.Table data={this.state.selectedTracks}
                                                          dataKeys={this.selectTracksKeys}
                                                          title={'Selected Tracks'}
                                                          options={this.selectedTracksListOptions()}/>
                                            </Fz.Column>
                                        </Fz.Row>
                                    </Fz.Column>

                                    <Fz.Column grid="lg" size="8">
                                        <Fz.Row>
                                            <Fz.Column grid="lg" size="5" classes="float-left">
                                                <Fz.PageSearch actionMethod={this.requestTableData}
                                                               searchable={['artist', 'title', 'album', 'album_artist']}/>
                                            </Fz.Column>
                                            <Fz.Column grid="lg" size="3">
                                                <div>
                                                    <label style={{marginTop: '6px'}}>
                                                        <input type="checkbox" id={this.dmcaCheckbox}
                                                               onChange={this.requestTableData} value="1"/>
                                                        <span className="checkbox-material">
                                                            <span className="check"/>
                                                        </span>
                                                        <span
                                                            className="checkbox-label">Show only royalty-free tracks</span>
                                                    </label>
                                                </div>
                                            </Fz.Column>
                                        </Fz.Row>

                                        <Fz.Row>
                                            <Fz.Table data={this.filterSelectedTracks()}
                                                      dataKeys={this.tableKeys}
                                                      title={'Music Library'} options={this.tracksListOptions()}/>
                                        </Fz.Row>

                                        <Fz.Row>
                                            <Fz.PaginatedButtons actionMethod={this.requestTableData}/>

                                            <Fz.PerPageSelector actionMethod={this.requestTableData}/>
                                        </Fz.Row>
                                    </Fz.Column>
                                </Fz.Row>
                            </div>
                        </div>
                    </Fz.Column>
                </div>

                <Fz.Modal openWhen={this.state.openCancelWarning}
                          title="Cancel?" closeText="Close"
                          saveText="Destroy Changes" afterClose={this.closeModal}
                          beforeSave={this.transitionToLibrary}
                          afterSave={this.closeModal}>
                    <p>Are you sure you wish to cancel&#63; Any changes made will be lost.</p>
                </Fz.Modal>

                <Fz.Modal openWhen={this.state.openPreviewModal}
                          title="Preview Cast" closeText="Continue Editing"
                          saveText="Save For Later" afterClose={this.closeModal}
                          beforeSave={this.performOperation}
                          afterSave={this.closeModal}
                          modalBodyClasses="cast-preview-modal"
                          disableSaveWhen={!this._castSatisfiesMinimum()}>
                    <CastPreview key={'cast:' + this.state.cast.id} cast={this.state.cast}
                                 instructor={this._castInstructor()}/>
                </Fz.Modal>

                <Fz.Modal openWhen={this.state.openUploadProgressModal}
                          title="Upload Progress" disableButtons={this.uploadProgress() !== '100%'}
                          afterClose={this.closeModal}
                          closeText="Continue Editing"
                          saveText="Continue to Cast Library"
                          beforeSave={this.transitionToLibrary}
                          afterSave={this.closeModal}>
                    <UploadProgress progressWidth={this.uploadProgress()}
                                    successText={this.state.cast.title + ' has been uploaded and is being transcoded. Check back in 10-15 minutes!'}/>
                </Fz.Modal>

                <Fz.Modal openWhen={this.state.openAddVoiceTrackModal}
                          title="Add Voice Track" closeText="Cancel"
                          saveText="Save and Transcode" afterClose={this.closeModal}
                          beforeSave={this.uploadVoiceTrack}
                          disableSaveWhen={!(this.state.castRecording.audio instanceof File)}>
                    <Fz.Row>
                        <Fz.Column grid="lg" size="6" classes="offset-lg-2">
                            <Fz.Form key={this.castRecordingFormKey + this.state.cast.id}
                                     formKey={this.castRecordingFormKey}
                                     bindResource={this.state.castRecording}>
                                <Fz.Form.File fieldKey="audio" options={{
                                    height: 60,
                                    width: 300,
                                    b64encoded: false,
                                    hidePreview: true
                                }}
                                              accept="audio"
                                              helpText="We recommend that you upload a FLAC file under 1 gig. The voice track must match the total length of music tracks."/>
                            </Fz.Form>
                        </Fz.Column>
                    </Fz.Row>
                    <Fz.Row>
                        <div>
                            <p>When clicking "Save and Transcode", the cast will be saved and the voice track
                                transcoded. This will NOT activate the cast; you must return to the Cast Library later
                                to activate this cast.</p>
                        </div>
                    </Fz.Row>
                </Fz.Modal>
            </div>
        );
    },
});

module.exports = TrackManagement;
